
function debounce(fn,delay){
  let _this = this; // 取debounce执行作用域的this
  return function () {
    let args = arguments;
    if (_this.timer) {
      clearTimeout(_this.timer);
    }
    _this.timer = setTimeout(function () {
      fn.apply(_this, args);
    }, delay);
  }
}
/*函数节流 */
function throttle(fn, gapTime) {
  if (gapTime == null || gapTime == undefined) {
    gapTime = 1500
  }
  let _lastTime = null
  // 返回新的函数
  return function () {
    let _nowTime = + new Date()
    if (_nowTime - _lastTime > gapTime || !_lastTime) {
      fn.apply(this, arguments)   //将this和参数传给原函数
      _lastTime = _nowTime
    }
  }
}
export default {debounce,throttle}